export default __webpack_public_path__ + "static/media/cours-collectifs-learn-english.ef53ae41.webp";